import styled, { css } from 'styled-components';

export const UpgradeListing = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    width: 100%;
    border-radius: 16px;
    padding: 24px;     
    background: radial-gradient(circle at bottom left, #67AFFF 0%, rgba(103, 175, 255, 0.9) 0%, rgba(103, 175, 255, 0.5) 20%, rgba(103, 175, 255, 0.15) 30%, #FFFFFF 40%);    

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  `}
`;

export const BenefitsWrapper = styled.div`
  ${({ theme }) => css`
    flex: 1;
    max-width: 30%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    gap: 64px 0;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      max-width: 100%;
      width: 100%;
    }
  `}
`;

export const BenefitsContent = styled.div``;

export const BenefitsSnappy = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BenefitsSnappyImage = styled.img`
  height: auto;
`;

export const BenefitsTitle = styled.h2`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['2xlarge']};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0 0 8px 0;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.large};
    }
  `}
`;

export const BenefitsDescription = styled.p`
  ${({ theme }) => css`
    margin: 0;
    font-size: ${theme.v3.font.sizes.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[20]};

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes.small};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const BenefitsResources = styled.div`
  margin: 24px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;    
`;

export const BenefitsResourcesTitle = styled.h3`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.medium};
    color: ${theme.v3.colors.neutral[20]};
    margin-bottom: 8px;
    padding: 0;
    margin: 0;    
  `}
`;

export const BenefitsResourcesItems = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;  
  margin: 0;
`;

export const BenefitsResourcesItem = styled.li`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;    
  `}
`;

export const PlanListsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 16px;
  flex: 1;
  padding: 0;
`;

export const PlanListsContent = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const PlanListItem = styled.li`
  ${({ theme }) => css`
    background-color: ${theme.v3.colors.neutral[100]};
    padding: 24px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;    
    gap: 12px;
    width: 100%;
    box-shadow: 0 8px 16px 0 #DFE2EB38, 0 12px 20px 0 #DFE2EB47;
  `}
`;

export const PlanListItemName = styled.h4`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.bold};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes.medium};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xmedium']};
    }    
  `}
`;

export const PlanListItemDetails = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }  
  `} 
`;

export const PlanListItemDescription = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 36px;
    flex: 1;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 24px;
    }  
  `}    
`;

export const PlanListItemResourcesItems = styled.p`
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;    
`;

export const PlanListItemResourcesItem = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;    

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes.small};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }    
  `}
`;

export const PlanListItemResourcesItemValueWrapper = styled.div``;

export const PlanListItemResourcesItemValue = styled.strong`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.bold};
  `}
`;

export const PlanListItemResourcesItemValueSuffix = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.v3.font.weights.regular};
  `}
`;

export const PlanListItemPrices = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0;
`;

export const PlanListItemFullPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 4px;
`;

export const PlanListItemFullPrice = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    margin: 0;
    white-space: break-spaces;
    text-wrap-mode: nowrap;
  `}
`;

export const PlanListItemFullPriceBillingCycle = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
  `}
`;

export const PlanListItemTextSeparator = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.mini};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
  `}
`;

export const PlanListItemMonthlyPrice = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xlarge']};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.bold};
    color: ${theme.v3.colors.neutral[20]};
    display: flex;
    align-items: baseline;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes.large};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes['1xlarge']};
    }       
  `}
`;

export const PlanListItemMonthlyPriceSuffix = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.bold};
    color: ${theme.v3.colors.neutral[20]};

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      font-size: ${theme.v3.font.sizes.mini};
    }

    @media (max-width: ${theme.v3.breakpoints.md}) {
      font-size: ${theme.v3.font.sizes.small};
    }       
  `}
`;

export const PlanListItemButtonWrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: ${theme.v3.breakpoints.md}) {
      width: 100%;
    }
  `}
`;

export const PlanListsNote = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.mini};
    line-height: ${theme.v3.font.lineHeight.comfortable};    
    font-weight: ${theme.v3.font.weights.regular};
    color: ${theme.v3.colors.neutral[30]};
    margin: 0;
  `}
`;
